import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import FounderSection from "./components/FounderSection";
import PricingSection from "./components/PricingSection";
import ArticlesSection from "./components/ArticlesSection";
import AcademiesSection from "./components/AcademiesSection";
import StatsSection from "./components/StatsSection";
import LegendsGallery from "./components/LegendsGallery";
import TestimonialsSection from "./components/TestimonialsSection";
import ServicesSection from "./components/ServicesSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <AboutSection />
      <FounderSection />
      <PricingSection />
      <ArticlesSection />
      <AcademiesSection />
      <StatsSection />
      <LegendsGallery />
      <TestimonialsSection />
      <ServicesSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
